export enum ExternalOrderProvider {
  WOLT = 'wolt',
  JET = 'jet',
  UBER_EATS = 'uber_eats',
  DELIVEROO = 'deliveroo',
}
